import React from "react";
import { usePageSeo, SectionTitle, TextBlock } from "../components/common";
import SignaturePhrase from "../components/SignaturePhrase";
import { ABOUT } from "../content";

export default function About() {
  usePageSeo({
    title: "Noëmie, ta sorcière préférée",
    description: "À propos de Noëmie : cartomancienne intuitive et énergéticienne. Des tirages intuitifs et des séances énergétiques à distance, guidés par l'intuition et les ressentis.",
    path: "/a-propos",
  });
  return (
    <div className="home-dark min-h-[80vh]">
      <div className="container-x py-12 sm:py-20 fade-up">
        <div className="grid lg:grid-cols-5 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-2 fade-up">
            <div className="home-portrait-wrap">
              <img
                src="/noemie-writing.png"
                alt="Noëmie, cartomancienne intuitive et énergéticienne"
                className="home-portrait"
                data-testid="about-photo"
              />
            </div>
          </div>
          <div className="lg:col-span-3">
            <div className="eyebrow mb-3 !text-[#DFC07B]">Rencontre</div>
            <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#F9F5EE]">
              À propos de moi
            </h1>
            <div className="gold-divider my-6 w-28" />
            <TextBlock text={ABOUT.intro} />
          </div>
        </div>

        <div className="mt-10 card-soft p-6 border-l-2 border-[#C9A56A]">
          <SignaturePhrase tone="dark" />
        </div>

        <div className="mt-12">
          <SectionTitle eyebrow="Ma pratique" title="Ma façon de travailler" />
          <div className="mt-6"><TextBlock text={ABOUT.work} /></div>
        </div>

        <div className="mt-12">
          <SectionTitle eyebrow="Ton libre arbitre" title="Une approche douce mais toujours libre" />
          <div className="mt-6"><TextBlock text={ABOUT.free} /></div>
        </div>

        <div className="mt-12 card-soft p-7">
          <TextBlock text={ABOUT.closing} tone="dark" className="text-center font-serif text-xl !text-[#5A3A4B]" />
          <div className="text-center mt-4">
            <a
              href="https://instagram.com/noemie.ta.sorciere.preferee"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-sm text-[#5A3A4B] underline"
              data-testid="about-instagram"
            >
              @Noemie.ta.sorciere.preferee
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
